module.exports = __webpack_public_path__ + "img/light_1_1.09b13b35.png";